export const RESOURCE_KINDS = ['domain', 'website', 'channel', 'account', 'publication'] as const;
export type ResourceKind = (typeof RESOURCE_KINDS)[number];
export const REGISTRY_SITE_SCOPES = ['published', 'references', 'all'] as const;
export type RegistrySiteScope = (typeof REGISTRY_SITE_SCOPES)[number];
export type ResourceSource = 'workspace' | 'telegram' | 'donor' | 'manual';
export interface RegistryResource {
  key: string;
  source: ResourceSource;
  sourceId: string;
  kind: ResourceKind;
  platform: ResourcePlatform;
  ownership: 'owned' | 'third_party' | 'unknown';
  roles: Array<'primary' | 'reference' | 'donor' | 'competitor'>;
  title: string;
  address: string;
  url: string | null;
  notes: string;
  revision?: number;
  siteScope?: Exclude<RegistrySiteScope, 'all'>;
}
export interface RegistryQuery {
  search?: string;
  kind?: ResourceKind;
  page?: number;
  siteScope?: RegistrySiteScope;
  role?: (typeof MANUAL_RESOURCE_ROLES)[number];
}
export interface RegistryPage {
  items: RegistryResource[];
  total: number;
  page: number;
  pageSize: number;
}
export interface RegistrySearch {
  groups: Array<{ kind: ResourceKind; items: RegistryResource[]; total: number }>;
  total: number;
}

import type { ResourcePlatform } from './registry-platform.js';
export type { ResourcePlatform } from './registry-platform.js';
export const RESOURCE_OWNERSHIP = ['owned', 'third_party', 'unknown'] as const;
export const MANUAL_RESOURCE_ROLES = ['donor', 'reference', 'competitor'] as const;
export interface ManualResourceInput {
  kind: ResourceKind;
  address: string;
  title: string;
  ownership: RegistryResource['ownership'];
  roles: Array<(typeof MANUAL_RESOURCE_ROLES)[number]>;
  notes: string;
}
export interface RegistryOwnershipSnapshot {
  readonly userId: string;
  readonly workspaceId: string;
  readonly index: ReadonlyMap<string, readonly RegistryOwnershipEvidence[]>;
}
export interface RegistryOwnershipEvidence {
  key: string;
  title: string;
  address: string;
  ownership: RegistryResource['ownership'];
  roles: RegistryResource['roles'];
  revision?: number;
  // competitor_subdomain retains the source record's ownership, not the result's.
  scope: 'host' | 'url' | 'telegram' | 'telegram_directory' | 'competitor_subdomain';
}
